/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useState } from 'react';

export default function useSubmissionTransfer(onDialogOpened, onDialogClosed, onConfirm, onConfrmationDialogClosed) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogValues, setDialogValues] = useState([]);
  const [submissionCount, setSubmissionCount] = useState(0);
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
  const [isError, setIsError] = useState(false);

  const openDialog = (submissionIds = []) => () => {
    const values = submissionIds instanceof Array ? submissionIds : [submissionIds];
    setIsDialogOpen(true);
    setDialogValues(values);
    onDialogOpened(submissionIds);
  };

  const closeDialog = () => {
    const currentValues = dialogValues;
    setDialogValues([]);
    setIsDialogOpen(false);
    onDialogClosed(currentValues);
  };

  const confirm = (values, destOrganizationId) => async () => {
    const submissionIds = values.map(s => s.id);
    setIsDialogOpen(false);
    setSubmissionCount(dialogValues.length);
    setDialogValues([]);
    onConfirm(submissionIds, destOrganizationId);
  };

  const openConfirmationDialog = (error) => {
    setIsError(error);
    setIsConfirmationDialogOpen(true);
  };

  const closeConfirmationDialog = () => {
    setIsConfirmationDialogOpen(false);
    onConfrmationDialogClosed(submissionCount);
  };

  return {
    transferDialog: {
      isOpen: isDialogOpen,
      open: openDialog,
      close: closeDialog,
      values: dialogValues,
      confirm,
    },
    transferConfirmationDialog: {
      isOpen: isConfirmationDialogOpen,
      open: openConfirmationDialog,
      close: closeConfirmationDialog,
      isError,
    },
  };
}
